export default __webpack_public_path__ + "static/media/xls.ca2dde30.svg";